import type { FC } from 'react';
import { lazy } from 'react';
import type { RemitReportingEntrypoint } from 'src/apis/remit-reporting/types';

const Page = lazy(() => import('./page'));

export const TsoReportsOverview: FC<{
  entrypoint: RemitReportingEntrypoint;
}> = ({ entrypoint }) => {
  return <Page entrypoint={entrypoint} />;
};
